import React, { PureComponent } from 'react';

import Grid from '@material-ui/core/Grid';

import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import ApiManager from '../../../Api/ApiManager';

import PickerListView from './PickerListView';
import UseFilterKey from '../../../Utils/UseFilterKey';

let updatableDataInitStates = {
  project: {
    isLoading: true,
    items: [] as any[],
    itemTotal: 0,
    paginationEnabled: false,
    limit: null as null,
    offset: null as null,
  },
  subsystem: {
    isLoading: true,
    items: [] as any[],
    itemTotal: 0,
    paginationEnabled: false,
    limit: null as null,
    offset: null as null,
  },
  model: {
    isLoading: true,
    items: [] as any[],
    itemTotal: 0,
    paginationEnabled: false,
    limit: null as null,
    offset: null as null,
  },
  tree: {
    isLoading: false,
    items: [] as any[],
    itemTotal: 0,
    paginationEnabled: true,
    limit: null as null,
    offset: null as null
  },
  selectedProjectId: null as null,
  selectedSubsystemId: null as null,
  selectedModelId: null as null,
  selectedTreeId: null as null,
};

interface Props extends RouteComponentProps<any> {
  validTreeTypes: string[];
  updateDialogTreeId: (id: number) => void;
  pickModelsOnly?: boolean;
  doGetModel: (model: any) => void;
  match: any;
}

interface Entity {
  isLoading: boolean;
  items: any[];
  itemTotal: number;
  paginationEnabled: boolean;
  limit: number | null | undefined;
  offset: number | null | undefined;
}

interface State {
  project: Entity;
  subsystem: Entity;
  model: Entity;
  tree: Entity;
  selectedProjectId: number | null;
  selectedSubsystemId: number | null;
  selectedModelId: number | null;
  selectedTreeId: number | null;
}

class PickerContainer extends PureComponent<Props, State> {
  localPagination = JSON.parse(localStorage.getItem("pagination"));
  isAutoPagination = !this.localPagination || (this.localPagination && this.localPagination.auto && !this.localPagination.rowsPerPage);

  constructor(props: Props) {
    super(props);

    if (!this.isAutoPagination) {
      const localRowsPerPage = this.localPagination.rowsPerPage;
      updatableDataInitStates = {
        ...updatableDataInitStates,
        project: {
          ...updatableDataInitStates.project,
          limit: localRowsPerPage
        },
        subsystem: {
          ...updatableDataInitStates.subsystem,
          limit: localRowsPerPage
        },
        model: {
          ...updatableDataInitStates.model,
          limit: localRowsPerPage
        },
        tree: {
          ...updatableDataInitStates.tree,
          limit: localRowsPerPage
        },
      }
    }

    this.state = { ...updatableDataInitStates };
  }

  deselectData = () => {
    this.setState({
      selectedProjectId: null,
      selectedSubsystemId: null,
      selectedModelId: null,
      selectedTreeId: null,
    });
  };

  getProjects = (keyword?: any, isSearch?: boolean) => {
    const { project: { limit, offset } } = this.state;
    const validKeyword = keyword && keyword.trim() !== "";
    if (validKeyword) {
      return ApiManager.searchHCLProjectsByKeyword(keyword, limit, isSearch ? 0 : offset)
        .then((response: any) => response.json())
        .then((data: any) => {
          this.setState(prevState => ({
            project: {
              ...prevState.project,
              items: data.results ? data.results : data,
              itemTotal: data && data.count ? data.count : data.length ? data.length : 0,
              paginationEnabled: !!(data && data.results),
              offset: isSearch ? 0 : offset,
              isLoading: false,
            },
          }), () => this.deselectData());
        });
    }
    return ApiManager.getHCLProjects(limit, offset)
      .then((response: any) => response.json())
      .then((data: any) => {
        this.setState(prevState => ({
          project: {
            ...prevState.project,
            items: data.results ? data.results : data,
            itemTotal: data && data.count ? data.count : data.length ? data.length : 0,
            paginationEnabled: !!(data && data.results),
            isLoading: false,
          }
        }));
      });
  };

  getSubsystems = (keyword?: any, isSearch?: boolean) => {
    const { subsystem: { limit, offset } } = this.state;
    const validKeyword = keyword && keyword.trim() !== "";
    if (validKeyword) {
      return ApiManager.searchHCLSubsystemsByKeyword(keyword, limit, offset)
        .then((response: any) => response.json())
        .then((data: any) => {
          this.setState(prevState => ({
            subsystem: {
              ...prevState.subsystem,
              items: data.results ? data.results : data,
              itemTotal: data && data.count ? data.count : data.length ? data.length : 0,
              paginationEnabled: !!(data && data.results),
              offset: isSearch ? 0 : offset,
              isLoading: false,
            },
          }), () => this.deselectData());
        });
    }
    return ApiManager.getHCLSubsystems(limit, offset)
      .then((response: any) => response.json())
      .then((data: any) => {
        this.setState(prevState => ({
          subsystem: {
            ...prevState.subsystem,
            items: data.results ? data.results : data,
            itemTotal: data && data.count ? data.count : data.length ? data.length : 0,
            paginationEnabled: !!(data && data.results),
            isLoading: false,
          },
        }));
      });
  };

  getModels = (keyword?: any, isSearch?: boolean) => {
    const { model: { limit, offset } } = this.state;
    const validKeyword = keyword && keyword.trim() !== "";
    if (validKeyword) {
      return ApiManager.searchHCLComponentsByKeyword(keyword, limit, offset)
        .then((response: any) => response.json())
        .then((data: any) => {
          this.setState(prevState => ({
            model: {
              ...prevState.model,
              items: data.results ? data.results : data,
              itemTotal: data && data.count ? data.count : data.length ? data.length : 0,
              paginationEnabled: !!(data && data.results),
              offset: isSearch ? 0 : offset,
              isLoading: false,
            },
          }), () => this.deselectData());
        })
    }
    return ApiManager.getHCLComponents(limit, offset)
      .then((response: any) => response.json())
      .then((data: any) => {
        this.setState(prevState => ({
          model: {
            ...prevState.model,
            items: data.results ? data.results : data,
            itemTotal: data && data.count ? data.count : data.length ? data.length : 0,
            paginationEnabled: !!(data && data.results),
            isLoading: false,
          },
        }));
      });
  };

  getTrees = (keyword?: any) => {
    const { tree: { limit, offset } } = this.state;
    const validKeyword = keyword && keyword.trim() !== "";
    if (validKeyword) {
      // TODO: add api method to search trees
    }
    return ApiManager.getTrees(limit, offset)
      .then(response => response.json())
      .then((data) => {
        this.setState(prevState => ({
          tree: {
            ...prevState.tree,
            items: this.hideCurrentTree(this.filterTreeTypes(data.results ? data.results : data)),
            itemTotal: data && data.count ? data.count : data.length ? data.length : 0,
            paginationEnabled: !!(data && data.results),
            isLoading: false,
          },
        }));
      });
  };

  getTreesByModelId = (modelId: number) => {
    const { tree: { limit, offset }, project, subsystem, model } = this.state;
    ApiManager.getTreesByModelId(modelId, limit, offset)
      .then((response: any) => response.json())
      .then((data: any) => {
        this.setState(prevState => ({
          tree: {
            ...prevState.tree,
            items: this.hideCurrentTree(this.filterTreeTypes(data.results ? data.results : data)),
            itemTotal: data && data.count ? data.count : data.length ? data.length : 0,
            paginationEnabled: !!(data && data.results),
            isLoading: false,
          }
        }))
      })
  };

  // Used to filter associated next column items
  // filterData = (filterKey: any) => {
  //   const {
  //     subsystem, model, tree,
  //     selectedProjectId, selectedSubsystemId, selectedModelId,
  //   } = this.state;
  //
  //   switch (filterKey) {
  //     case 'Subsystems':
  //       return ApiManager.getSubsystemsByProjectId(selectedProjectId)
  //         .then(response => response.json())
  //         .then((data) => {
  //           this.setState(prevState => ({
  //             subsystem: {
  //               ...prevState.subsystem,
  //               items: data.results ? data.results : data,
  //               filterInput: subsystem.filterInput,
  //               isLoading: false,
  //             },
  //           }));
  //         });
  //     case 'Models':
  //       return ApiManager.getModelsBySubsystemId(selectedSubsystemId)
  //         .then(response => response.json())
  //         .then((data) => {
  //           this.setState(prevState => ({
  //             model: {
  //               ...prevState.model,
  //               items: data.results ? data.results : data,
  //               filterInput: model.filterInput,
  //               isLoading: false,
  //             },
  //           }));
  //         });
  //     case 'Trees':
  //       const { tree: { limit, offset }} = this.state;
  //       return ApiManager.getHCLModel(`/${selectedModelId}/tree`, limit, offset)
  //         .then(response => response.json())
  //         .then((data) => {
  //           this.setState(prevState => ({
  //             tree: {
  //               ...prevState.tree,
  //               items: this.hideCurrentTree(this.filterTreeTypes(data.results ? data.results : data)),
  //               itemTotal: data && data.count ? data.count : data.length ? data.length : 0,
  //               filterInput: tree.filterInput,
  //               isLoading: false,
  //             },
  //           }));
  //         });
  //     default: return;
  //   }
  // };

  // Used to initiate FilterData
  handlePickerClick = (entity: any, id: number) => {
    const { pickModelsOnly, doGetModel, updateDialogTreeId } = this.props;
    const {
      project, subsystem, model, selectedProjectId, selectedSubsystemId, selectedModelId, selectedTreeId
    } = this.state;

    if (selectedProjectId !== id && entity === 'Projects') {
      this.setState({
        selectedProjectId: id,
        selectedSubsystemId: null,
        selectedModelId: null,
        // selectedTreeId: null,
        // model: { ...updatableDataInitStates.model, isLoading: false },
        // tree: { ...updatableDataInitStates.tree, isLoading: false },
      }, () => {
        // if (pickModelsOnly) doGetModel(project.items.find(x => x.id === id));
        // this.filterData('Subsystems');
        this.getTreesByModelId(id);
      });
    } else if (selectedSubsystemId !== id && entity === 'Subsystems') {
      this.setState({
        selectedSubsystemId: id,
        selectedProjectId: null,
        selectedModelId: null,
        // selectedTreeId: null,
        // tree: { ...updatableDataInitStates.tree, isLoading: false },
      }, () => {
        // if (pickModelsOnly) doGetModel(subsystem.items.find(x => x.id === id));
        // this.filterData('Models');
        this.getTreesByModelId(id)
      });
    } else if (selectedModelId !== id && entity === 'Models') {
      this.setState({
        selectedModelId: id,
        selectedProjectId: null,
        selectedSubsystemId: null,
        // selectedTreeId: null,
      }, () => {
        // if (pickModelsOnly) doGetModel(model.items.find(x => x.id === id));
        // this.filterData('Trees');
        this.getTreesByModelId(id)
      });
    } else if (entity === 'Trees') {
      this.setState({
        selectedTreeId: id,
      }, () => updateDialogTreeId(id));
    }
  };

  // Used to hide specific tree types based on current tree
  filterTreeTypes = (data: any) => {
    const { validTreeTypes } = this.props;
    return data.filter((item: any) => validTreeTypes.includes(item.tree_type));
  };

  // Used to hide current tree from list
  hideCurrentTree = (data: any) => {
    const { match: { params: { treeId } }} = this.props;
    try {
      return data.filter((item: any) => {
        if (this.props.match.params.treeType.charAt(0) === item.tree_type) {
          if (parseInt(treeId) === item.id) {
            return null;
          }
          return item;
        }
        return item;
      });
    } catch (e) {
      console.error(e);
      return data;
    }

  };

  // Used to update items when pagination is enabled
  updateCollection = (entity: string, limit: number, offset: number) => {
    const { selectedProjectId, selectedSubsystemId, selectedModelId, selectedTreeId } = this.state;
    switch (entity) {
      case 'Projects':
        return this.setState(prevState => ({
          project: {
            ...prevState.project,
            limit,
            offset
          },
        }), () => this.getProjects());
      case 'Subsystems':
        return this.setState(prevState => ({
          subsystem: {
            ...prevState.subsystem,
            limit,
            offset
          },
        }), () => {
          this.getSubsystems();
          // if (!selectedProjectId) {
          //   this.getSubsystems();
          // } else {
          //   return null
          //   // this.filterData('Subsystems');
          // }
        });
      case 'Models':
        return this.setState(prevState => ({
          model: {
            ...prevState.model,
            limit,
            offset
          },
        }), () => {
          this.getModels();
          // if (!selectedSubsystemId) {
          //   this.getModels();
          // } else {
          //   return null
          //   // this.filterData('Models');
          // }
        });
      case 'Trees':
        return this.setState(prevState => ({
          tree: {
            ...prevState.tree,
            limit,
            offset
          },
        }), () => {
          // if (!selectedModelId) {
          //   this.getTrees();
          // }
          let modelIdSelection = [selectedProjectId, selectedSubsystemId, selectedModelId];
          modelIdSelection = modelIdSelection.find((x: any) => x !== null);
          if (modelIdSelection) {
            this.getTreesByModelId(modelIdSelection)
          } else {
            this.getTrees();
          }
        });
      default:
        return;
    }
  };

  render() {
    const { pickModelsOnly } = this.props;
    const {
      project, selectedProjectId, subsystem, selectedSubsystemId,
      model, selectedModelId, tree, selectedTreeId,
    } = this.state;

    const isLoading = project.isLoading || subsystem.isLoading || model.isLoading || tree.isLoading;

    return (
      <Grid container spacing={2}>
        <UseFilterKey
          loadData={this.getProjects}
          render={({ filterInput, handleFilterChange, handleFilterSubmit }: any) => (
            <PickerListView
              listTitle="Projects"
              entity={project}
              selectedEntityId={selectedProjectId}
              pickModelsOnly={pickModelsOnly}
              filterInput={filterInput}
              handleFilterChange={ (e) => {
                handleFilterChange(e);
                this.getProjects(e.target.value, true);
              }}
              handleFilterSubmit={handleFilterSubmit}
              doPickerClick={(id: number) => this.handlePickerClick('Projects', id)}
              updateList={(limit: number, offset: number) => this.updateCollection('Projects', limit, offset)}
              listViewId="projectListView"
            />
          )}
        />
        <UseFilterKey
          loadData={this.getSubsystems}
          render={({ filterInput, handleFilterChange, handleFilterSubmit }: any) => (
            <PickerListView
              listTitle="Subsystems"
              entity={subsystem}
              selectedEntityId={selectedSubsystemId}
              pickModelsOnly={pickModelsOnly}
              filterInput={filterInput}
              handleFilterChange={ (e) => {
                handleFilterChange(e);
                this.getSubsystems(e.target.value, true);
              }}
              handleFilterSubmit={handleFilterSubmit}
              doPickerClick={(id: number) => this.handlePickerClick('Subsystems', id)}
              updateList={(limit: number, offset: number) => this.updateCollection('Subsystems', limit, offset)}
              listViewId="subsystemListView"
            />
          )}
        />
        <UseFilterKey
          loadData={this.getModels}
          render={({ filterInput, handleFilterChange, handleFilterSubmit }: any) => (
            <PickerListView
              listTitle="Components"
              entity={model}
              selectedEntityId={selectedModelId}
              pickModelsOnly={pickModelsOnly}
              filterInput={filterInput}
              handleFilterChange={ (e) => {
                handleFilterChange(e);
                this.getModels(e.target.value, true);
              }}
              handleFilterSubmit={handleFilterSubmit}
              doPickerClick={(id: number) => this.handlePickerClick('Models', id)}
              updateList={(limit: number, offset: number) => this.updateCollection('Models', limit, offset)}
              listViewId="modelListView"
            />
          )}
        />
        {!pickModelsOnly && (
          <UseFilterKey
            loadData={this.getTrees}
            render={({ filterInput, handleFilterChange, handleFilterSubmit }: any) => (
              <PickerListView
                listTitle="Trees"
                entity={tree}
                selectedEntityId={selectedTreeId}
                filterInput={filterInput}
                handleFilterChange={handleFilterChange}
                doFrontEndFilter
                handleFilterSubmit={handleFilterSubmit}
                doPickerClick={(id: number) => this.handlePickerClick('Trees', id)}
                updateList={(limit: number, offset: number) => this.updateCollection('Trees', limit, offset)}
                listViewId="treeListView"
              />
            )}
          />
        )}
      </Grid>
    );
  }
}

export default withRouter(PickerContainer);
